import { NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX, SANDBOX_HOST } from "@/platform/api/constants"

// Client-side gate for BNPL sandbox mode: the request is on the sandbox checkout host.
const isSandboxMode = (): boolean => typeof window !== "undefined" && window.location.hostname === SANDBOX_HOST

// Sandbox api-v2 base URL for client-side calls, or undefined to stay on prod.
// Inert (undefined) off the sandbox host or until NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX is set.
export const getSandboxApiBaseUrl = (): string | undefined => (isSandboxMode() && NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX ? NEXT_PUBLIC_NELO_API_BASE_URL_SANDBOX : undefined)

// Stripe publishable key for the account the sandbox api creates PaymentIntents on, or undefined to stay on prod.
// Inert (undefined) off the sandbox host or until NEXT_PUBLIC_STRIPE_KEY_SANDBOX is set.
export const getSandboxStripeKey = (): string | undefined => (isSandboxMode() && process.env.NEXT_PUBLIC_STRIPE_KEY_SANDBOX) || undefined
